import { Global } from "@emotion/react";

// Inter itself comes from @fontsource/inter (woff2, imported in index.tsx);
// this holds the global layout classes.
const Fonts = () => (
	<Global
		styles={`
.responsive-grid:not([class$="grid"]) {
    --max-col-width: var(--m-col-w, 10rem);
    --min-row-height: var(--m-row-h, 5rem);
	--max-cols: var(--m-col-s, 3);
	--gap: var(--c-gap, 1rem);
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(min(100%, max(var(--max-col-width), (100% / var(--max-cols)) - var(--gap))),
	1fr));
	grid-auto-rows: minmax(var(--min-row-height), auto);
	gap: var(--gap);
}
.metrics-container {
    --m-col-w: 4rem;
    --m-row-h: 1rem;
    --m-col-s: 2;
    --c-gap: .75em;
}
.rect-clipped {
    clip-path: inset(0 0 100% 100%);
}
.responsive-grid:not(.rect-clipped) {
   clip-path: inset(0);
}
.map-container {
    container: map / inline-size;
}
[class$="grid"]:not(.rdp-month *) {
    --col-align: center;
    display: grid;
    grid-template: var(--g-template);
    gap: var(--g-gap, 1rem);
    place-items: var(--p-items, initial);

    &> :first-of-type {
        grid-area: area1;
    }

    &> :nth-of-type(2) {
        grid-area: area2;
    }

    &> :nth-of-type(3) {
        grid-area: area3;
    }

    &> :nth-of-type(4) {
        grid-area: area4;
    }

    &> :nth-of-type(5) {
        grid-area: area5;
    }
}

p {
    text-wrap: pretty;
}
.tendering-grid {
    --g-template: "area1" "area2" "area3" "area4" "area5" / 1fr;
    border-radius: .5rem;
    border: 1px solid var(--chakra-colors-grey-100);
    background-color: white;
    padding: .75rem;
    place-self: stretch;
}
.topic-grid {
    --g-template: "area1 area2" / 1fr 1fr;
    --g-gap: .5rem;
    --s-gap: .25rem;
}
.request-grid {
    --g-template: "area1 area2 area3" / 1fr 1fr 1fr;
    --g-gap: 1rem;
    --s-grap: .5rem;
}

.topic-stack:not(.info-box *) {
    overflow: hidden;
    white-space: nowrap;
}

:where(.stack, .topic-stack)>*+* {
    margin-block-start: var(--s-gap, .5rem);
}

.i-flex {
    display: inline-flex;
    gap: .5rem;
    align-items: center;
}

.pre-x-click::before,
.post-x-click::after {
    content: "";
    position: absolute;
    inset: 0;
}

.one-line:not(.info-box *) {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.tender-box {
    --m-col-w: 9rem;
}

@container map (inline-size > 548px) {
    .metrics-container {
        --m-col-w: 10rem;
        --m-row-h: 5rem;
        --c-gap: 1em;
        --m-col-s: 4;
    }
}
@container (inline-size > 375px) {
    .tendering-grid {
        --g-template: "area1 area1" "area2 area2" "area3 area4" "area5 area5" / 1fr 1fr;
    }
}
@container map (inline-size <= 548px) {
    .responsive-grid > .metric-card {
        display: none;
    }
}
@container map (inline-size > 548px) {
    .responsive-grid > .metric-button {
        display: none;
    }
}
      `}
	/>
);

export default Fonts;
